
// import router from '../../../router/index'
import config from 'config-chain'
import { authHeader } from '../_helpers'
import BaseService from '../../../backend/vue-axios/axios.js'
import { store } from '../../../backend/vuex-storage/globalStoreParameters'

export const userService = {
  login,
  logout,
  getAll,
  refreshToken,
  getAccessToken
}

function login (username, password) {
  const requestOptions = {
    userName: username,
    password: password
  }

  return BaseService.Login(requestOptions)
    .then(res => {
      // console.log(res)
      // debugger // eslint-disable-line
      if (res.data.success) {
        store.commit('setJWTTokenItem', res.data.result)
      }
      if (res.data.result.jwtToken) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', 'LogedIn')
        localStorage.setItem('userRefreshToken', res.data.result.refreshToken)
      }
      return res.data
    })
    //   return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
    //     .then(handleResponse)
    //     .then(user => {
    //       // login successful if there's a jwt token in the response
    //       if (user.token) {
    //         // store user details and jwt token in local storage to keep user logged in between page refreshes
    //         localStorage.setItem('user', JSON.stringify(user))
    //       }

  //       return user
  //     })
}

function logout () {
  // remove user from local storage to log user out
  store.commit('remJWTTokenItem')
  localStorage.removeItem('user')
  localStorage.removeItem('userRefreshToken')
}

function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse)
}
function getAccessToken () {
  return store.getters.getAccessToken
}
function refreshToken () {
  const RefreshTokenVal = { token: store.getters.getRefreshToken }
  return BaseService.RefreshJWTToken(RefreshTokenVal)
    .then(res => {
      if (res.data.success) {
        store.commit('setJWTTokenItem', res.data.result)
        localStorage.setItem('user', 'Loged In')
        localStorage.setItem('userRefreshToken', res.data.result.refreshToken)
      } else {
        if (res.data.error.statusCode === 400) {
          logout()
          // router.replace('/')
        } else {
        }
      }
      // console.log(res)
    })

  // debugger; // eslint-disable-line
  // const RefreshTokenVal = { token: localStorage.refreshtoken }
  // const RefreshTokenVal = { token: store.getters.getRefreshToken }
  // return BaseService.RefreshJWTToken(RefreshTokenVal)
  //   .then(res => {
  //     if (!res.data.success && res.data.error.statusCode === 400) {
  //       logout()
  //       location.reload(true)
  //     } else {
  //       store.commit('setJWTTokenItem', res.data.result)
  //     }
  //   }, error => {
  //     console.log(error)
  //   })
}
function handleResponse (response) {
  // if (!response.ok) {
  //   if (response.status === 401) {
  //     // auto logout if 401 response returned from api
  //     // logout()
  //     // location.reload(true)
  //     refreshToken()
  //   }
  // }
}
